module.exports = __webpack_public_path__ + "img/skoda-logo.ca402e67.svg";